import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import React, { memo, useEffect } from 'react';
import * as Yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormAutocompleteField from 'components/ui/form/FormAutocompleteField';
import FormSelectField from 'components/ui/form/FormSelectField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = Yup.object().shape({
  status: Yup.number().required('Statusni tanlash majburiy!'),

  deliver_id: Yup.number()
    .nullable()
    .when('status', {
      is: 3,
      then: (schema) =>
        schema.required('Yetkazuvchi shaxs tanlanishi majburiy!'),
    }),
});

const ChangeStatus = (props) => {
  const { open, setOpen, setRefetch, itemData, setItemData } = props;
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      status: '',
      deliver_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        `/admin/orders/updatestatus/${itemData?.id}`,
        "Status o'zgartirildi",
        null,
        true,
        handleFinishRequest
      );
    },
  });

  useEffect(() => {
    if (itemData?.id) {
      formik.setValues({
        status: itemData?.status || '',
        deliver_id: itemData?.deliver_id || '',
      });
    }
  }, [itemData]);

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemData({});
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        Buyurtma statusini o'zgartirish
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSelectField
                delay={0.1}
                label={'Status'}
                fieldName='status'
                fullWidth
                formik={formik}
                path={'/dictionary/orders-tatuses'}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormAutocompleteField
                delay={0.2}
                label={'Yetkazib beruvchi'}
                fieldName='deliver_id'
                formik={formik}
                disabled={formik.values.status != 3}
                fullWidth
                autocomplete='off'
                path={'/dictionary/users'}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.3}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ChangeStatus);
